import React from 'react';
import {Checkbox, SvgIcon} from '@material-ui/core';
import type {CheckboxProps} from '@material-ui/core';
import {ReactComponent as Unchecked} from 'assets/icons/checkbox/unchecked.svg';
import {ReactComponent as Checked} from 'assets/icons/checkbox/checked.svg';
import {ReactComponent as Mixed} from 'assets/icons/checkbox/mixed.svg';

function EfeCheckbox(props: CheckboxProps) {
    const icon = (
        <SvgIcon>
            <Unchecked />
        </SvgIcon>
    );

    const checked = (
        <SvgIcon>
            <Checked />
        </SvgIcon>
    );

    const indeterminate = (
        <SvgIcon>
            <Mixed />
        </SvgIcon>
    );

    return (
        <Checkbox
            icon={icon}
            indeterminateIcon={indeterminate}
            checkedIcon={checked}
            {...props}
        />
    );
}

export default EfeCheckbox;
